import { Builder } from '@builder.io/react'
import CdnImage from 'components/util/CdnImage'
// import CloudinaryImage from 'components/util/CloudinaryImage'
import { HeadingClass, HeadingType } from 'enums'
import React from 'react'
import Slider from 'react-slick'
import LinkButton, { LinkButtonProp } from '../common/button'
import CustomHeading, { headingTypePropObj } from '../common/heading'
import './instagram-section.css'

enum Alignment {
  Center = 'center',
  Left = 'left',
  Right = 'right'
}
interface Step {
  // cloudinaryImage: any
  builderImage: any
  imageAltText: string
  stepBackgroundColor: string
  optimalImgEnable: boolean
}
interface Props {
  topBanner: string
  topBannerMobile: string
  backgroundColor: string
  headingText: string
  headingTextColor: string
  headingType: HeadingType
  headingClass: HeadingClass
  subText: string
  subTextColor: string
  steps: Step[]
  buttonEnabled: boolean
  buttonOneProp: LinkButtonProp
  imageProperty: string
  imageOrientation: 'landscape' | 'portrait'
  href: string
}

function SamplePrevArrow(props: any) {
  const { className, style, onClick } = props
  return (
    <div
      className={className}
      style={{
        ...style,
        display: 'flex',
        justifyContent: 'center',
        zIndex: 2,
        left: '-14px !important',
        top: '50% !imporatant',
        transform: 'translateY(-50%) !important'
      }}
      onClick={onClick}
    />
  )
}

function SampleNextArrow(props: any) {
  const { className, style, onClick } = props
  return (
    <div
      className={className}
      style={{
        ...style,
        display: 'flex',
        justifyContent: 'center',
        zIndex: 2,
        right: '-14px !important',
        top: '50% !imporatant',
        transform: 'translateY(-50%) !important'
      }}
      onClick={onClick}
    />
  )
}

const settingsDesktop = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />
}

const settingsMobile = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 2.2,
  slidesToScroll: 1,
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />
}

const InstagramSection = ({
  topBanner,
  topBannerMobile,
  backgroundColor,
  headingText,
  headingTextColor,
  headingType,
  headingClass,
  subText,
  subTextColor,
  steps,
  buttonOneProp,
  buttonEnabled,
  imageProperty,
  imageOrientation,
  href
}: Props) => {
  function getImgOrientationMobile() {
    if (imageOrientation === 'landscape') {
      return 'h-44'
    }
    return 'h-48'
  }
  function getImgOrientationDesktop() {
    if (imageOrientation === 'landscape') {
      return 'h-44'
    }
    return 'h-80'
  }

  return (
    <>
      {topBanner && (
        <div
          className="relative -mt-4 h-16 w-full bg-cover bg-bottom bg-no-repeat hidden lg:block"
          style={{
            backgroundColor,
            backgroundImage: topBanner ? `url(${topBanner})` : 'none'
          }}
        ></div>
      )}
      {topBannerMobile && (
        <div
          className="relative -mt-4 h-8 w-full bg-cover bg-bottom bg-no-repeat block lg:hidden"
          style={{
            backgroundColor,
            backgroundImage: topBannerMobile ? `url(${topBannerMobile})` : 'none'
          }}
        ></div>
      )}
      <div
        className={`m-auto w-full lg:mb-4 ${topBanner ? 'lg:mt-16' : ''} ${topBannerMobile ? 'my-12' : 'mb-12 mt-2'}`}
        style={{ backgroundColor }}
      >
        <CustomHeading
          classList="text-center"
          headingClass={headingClass}
          headingType={headingType}
          color={headingTextColor}
        >
          {headingText}
        </CustomHeading>
        <p
          className="text-base md:text-lg text-white text-center w-11/12 md:w-1/2 mx-auto"
          style={{ color: subTextColor }}
        >
          {subText}
        </p>
        <div className="mx-auto max-w-7xl py-5 sm:px-2 sm:pt-10 lg:px-4">
          {/* ================= Mobile Slider start */}
          <div className="relative flex justify-center md:hidden">
            <Slider {...settingsMobile} style={{ width: '85%' }}>
              {steps?.map((step: Step, i: number) => (
                <div key={i} className="mx-auto !flex h-full max-w-sm justify-center">
                  <div
                    className="mx-2 my-0 flex w-full flex-col rounded-2xl"
                    style={{ backgroundColor: step?.stepBackgroundColor || '#FFFFFF', borderRadius: '2rem' }}
                  >
                    <a
                      className={`w-full sm:flex-shrink-0 ${getImgOrientationMobile()}`}
                      href={href}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <CdnImage
                        className={`${imageProperty} block rounded-3xl object-cover`}
                        url={step.builderImage}
                        alt={step.imageAltText}
                        steps={[300]}
                        style={{
                          width: '300px',
                          height: '280px',
                          maxHeight: '100%',
                          maxWidth: '100%'
                        }}
                      />
                      {/* {step.builderImage ? (
                        <CdnImage
                          className={`${imageProperty} block rounded-3xl object-cover`}
                          url={step.builderImage}
                          alt={step.imageAltText}
                          steps={[300]}
                          style={{
                            width: '300px',
                            height: '280px',
                            maxHeight: '100%',
                            maxWidth: '100%'
                          }}
                        />
                      ) : (
                        <CloudinaryImage
                          className={`${imageProperty} block rounded-3xl object-cover`}
                          publicId={step.cloudinaryImage?.public_id}
                          alt={step.imageAltText}
                          steps={[300]}
                          style={{
                            width: '300px',
                            height: '280px',
                            maxHeight: '100%',
                            maxWidth: '100%'
                          }}
                        />
                      )} */}
                    </a>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
          {/* ================= Mobile Slider End*/}

          {/* ============ Desktop slider for >=5 card Start =============*/}
          <div className="hidden md:flex md:justify-center">
            <Slider {...settingsDesktop} style={{ width: '95%' }}>
              {steps?.map((step: Step, i: number) => (
                <div key={i} className="mx-auto !flex h-full !w-11/12">
                  <div className="mx-2 flex w-full flex-col rounded-2xl" style={{ borderRadius: '2rem' }}>
                    <a
                      className={`w-full sm:flex-shrink-0 ${getImgOrientationDesktop()}`}
                      href={href}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <CdnImage
                        className={`${imageProperty} block max-h-[120px] w-full rounded-3xl object-cover xs:min-h-[120px] md:max-h-full`}
                        url={step.builderImage}
                        alt={step.imageAltText}
                        steps={[400, 300]}
                        style={{
                          height: '330px',
                          maxHeight: '100%',
                          maxWidth: '100%'
                        }}
                      />
                      {/* {step.builderImage ? (
                        <CdnImage
                          className={`${imageProperty} block max-h-[120px] w-full rounded-3xl object-cover xs:min-h-[120px] md:max-h-full`}
                          url={step.builderImage}
                          alt={step.imageAltText}
                          steps={[400, 300]}
                          style={{
                            height: '330px',
                            maxHeight: '100%',
                            maxWidth: '100%'
                          }}
                        />
                      ) : (
                        <CloudinaryImage
                          className={`${imageProperty} block max-h-[120px] w-full rounded-3xl object-cover xs:min-h-[120px] md:max-h-full`}
                          publicId={step.cloudinaryImage?.public_id}
                          alt={step.imageAltText}
                          steps={[400, 300]}
                          style={{
                            height: '330px',
                            maxHeight: '100%',
                            maxWidth: '100%'
                          }}
                        />
                      )} */}
                    </a>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
          {/* =============== Desktop slider for >=5 card End =============== */}
          {buttonEnabled && (
            <div
              className="mx-auto flex w-full flex-col justify-center px-4 pt-10 text-center lg:w-1/2"
              style={{ backgroundColor }}
            >
              <LinkButton
                buttonColor={buttonOneProp.buttonColor}
                buttonUrl={buttonOneProp.buttonUrl}
                buttonText={buttonOneProp.buttonText}
                loggedInButtonText={buttonOneProp.loggedInButtonText}
                buttonTextColor={buttonOneProp.buttonTextColor}
                isLink={false}
                classList={
                  'px-5 py-3 mt-4 border border-transparent text-base font-medium rounded-full md:py-4 md:text-lg md:px-10 w-full md:w-3/5 mx-auto'
                }
              />
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default InstagramSection

Builder.registerComponent(InstagramSection, {
  name: 'InstagramSection',
  inputs: [
    {
      name: 'topBanner',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'topBannerMobile',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      ...headingTypePropObj
    },
    {
      name: 'headingClass',
      type: 'string',
      enum: ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'],
      defaultValue: 'H1'
    },
    {
      name: 'headingText',
      type: 'string',
      defaultValue: 'Sample Heading'
    },
    {
      name: 'headingTextColor',
      type: 'color',
      defaultValue: 'black'
    },
    {
      name: 'headingAlignment',
      type: 'string',
      enum: ['left', 'center', 'right'],
      defaultValue: 'center'
    },
    {
      name: 'subText',
      type: 'text',
      defaultValue: 'Sample subtext'
    },
    {
      name: 'subTextColor',
      type: 'color',
      defaultValue: 'black'
    },
    {
      name: 'steps',
      type: 'list',
      defaultValue: [
        {
          imageSrc: null,
          imageAltText: '',
          stepBackgroundColor: '#F9F5F1',
          optimalImgEnable: true
        }
      ],
      subFields: [
        // { name: 'cloudinaryImage', type: 'cloudinaryImageEditor' },
        {
          name: 'builderImage',
          type: 'file',
          allowedFileTypes: ['jpeg', 'png', 'svg']
        },
        { name: 'imageAltText', type: 'text', defaultValue: '' },
        { name: 'stepBackgroundColor', type: 'color', defaultValue: '#F9F5F1' },
        { name: 'optimalImgEnable', type: 'boolean', defaultValue: true }
      ]
    },
    {
      name: 'buttonOneProp',
      type: 'object',
      defaultValue: {
        buttonColor: 'white',
        buttonText: 'Create Your Plan',
        buttonTextColor: 'black',
        buttonUrl: '#',
        isLink: false
      },
      subFields: [
        { name: 'buttonColor', type: 'color', defaultValue: 'white' },
        { name: 'buttonText', type: 'string', defaultValue: 'Create Your Plan' },
        { name: 'loggedInButtonText', type: 'string', defaultValue: 'Logged In' },
        { name: 'buttonTextColor', type: 'color', defaultValue: 'black' },
        { name: 'buttonUrl', type: 'text', defaultValue: '#' },
        { name: 'isLink', type: 'boolean', defaultValue: false }
      ]
    },
    { name: 'href', type: 'string', defaultValue: '#' },
    {
      name: 'buttonEnabled',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'imageProperty',
      type: 'string',
      enum: ['object-contain', 'object-cover'],
      defaultValue: 'object-cover'
    },
    {
      name: 'imageOrientation',
      type: 'text',
      enum: ['landscape', 'portrait'],
      defaultValue: 'portrait'
    }
  ]
})
